import React, { useState, useEffect } from "react";
import dayjs from "dayjs";

import {
  GridItem,
  Box,
  Text,
  Input,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Checkbox,
  VStack,
  Stack,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Select,
  Heading,
} from "@chakra-ui/react";

import { useTranslation } from "react-i18next";

const DialogEnrollSubject = ({
  dialogEnrollSubjectToggle,
  closeDialogEnrollSubject,
  handleSubmitEnrollSubject,
  enrollState,
  setEnrollState,
  formQuestionare,
  setFormQuestionare,
  subjectData,
}) => {
  const today = dayjs();
  const [birthDay, setBirthDay] = useState(today.format("DD"));
  const [birthMonth, setBirthMonth] = useState(today.format("MM"));
  const [birthYear, setBirthYear] = useState(today.format("YYYY"));
  const [daysInMonth, setDaysInMonth] = useState(today.daysInMonth());

  useEffect(() => {
    if (birthDay && birthMonth && birthYear) {
      handleDayOfmounth();
      const formatted = `${birthYear.padStart(4, "0")}-${birthMonth.padStart(2, "0")}-${birthDay.padStart(2, "0")}`;
      setFormQuestionare((prev) => ({ ...prev, birthDate: formatted }));
    }
  }, [birthDay, birthMonth, birthYear]);
  const handleDayOfmounth = () => {
    setDaysInMonth(dayjs(`${birthYear}-${birthMonth}`).daysInMonth());
  };
  console.log("🚀 ~ subjectData:", daysInMonth, formQuestionare);
  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormQuestionare((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckbox = (name, values) => {
    setFormQuestionare((prev) => ({ ...prev, [name]: values }));
  };
  const { t } = useTranslation();
  return (
    <Modal size={"lg"} isOpen={dialogEnrollSubjectToggle} onClose={closeDialogEnrollSubject}>
      <ModalOverlay />
      <form onSubmit={handleSubmitEnrollSubject} as={GridItem} colSpan={[6, 3]}>
        <ModalContent maxW="800px" maxHeight="80vh" minHeight="600px">
          <ModalHeader>
            <Heading fontSize="xl">{t("DialogEnrollSubject.questionnaire")}</Heading>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody overflowY="auto">
            <VStack w="full" align="start">
              <Checkbox onChange={(e) => setEnrollState({ creditstatus: e.target.checked })}>
                <Text>{t("subjectPage.request_credit")}</Text>
              </Checkbox>
              <Checkbox onChange={(e) => setEnrollState({ certificatestatus: e.target.checked })}>
                <Text>{t("subjectPage.request_certificate")}</Text>
              </Checkbox>
              {enrollState?.certificatestatus && (
                <Box w="full" py={3}>
                  <Text>{t("subjectPage.name_certificate")}</Text>
                  <Input
                    placeholder={t("subjectPage.name_placeholder")}
                    onChange={(e) => setEnrollState({ name: e.target.value })}
                  />
                  <Text color={"red.500"}>{t("subjectPage.text_enroll")}</Text>
                </Box>
              )}
            </VStack>
            {subjectData?.questionnaire && (
              <Stack spacing={4}>
                <FormControl>
                  <FormLabel>{t("DialogEnrollSubject.name")}</FormLabel>
                  <Stack direction={["column", "row"]} spacing={4}>
                    <Input
                      name="firstName"
                      placeholder={t("DialogEnrollSubject.firstName")}
                      value={formQuestionare.firstName}
                      onChange={handleInput}
                    />
                    <Input
                      name="lastName"
                      placeholder={t("DialogEnrollSubject.lastName")}
                      value={formQuestionare.lastName}
                      onChange={handleInput}
                    />
                  </Stack>
                </FormControl>

                <FormControl>
                  <FormLabel>{t("DialogEnrollSubject.gender")}</FormLabel>
                  <RadioGroup
                    name="gender"
                    value={formQuestionare.gender}
                    onChange={(val) => setFormQuestionare((prev) => ({ ...prev, gender: val }))}
                  >
                    <Stack spacing={2}>
                      <Radio value="ชาย">1. {t("DialogEnrollSubject.gender_options.male")}</Radio>
                      <Radio value="หญิง">2. {t("DialogEnrollSubject.gender_options.female")}</Radio>
                      <Radio value="ไม่ระบุ">3. {t("DialogEnrollSubject.gender_options.unspecified")}</Radio>
                    </Stack>
                  </RadioGroup>
                </FormControl>

                <FormControl>
                  <FormLabel>{t("DialogEnrollSubject.birthDate")}</FormLabel>
                  <Stack direction={["column", "row"]} spacing={4}>
                    <Select
                      placeholder="วัน"
                      value={birthDay}
                      onChange={(e) => {
                        setBirthDay(e.target.value);
                      }}
                    >
                      {Array.from({ length: daysInMonth }, (_, i) => (
                        <option key={i + 1} value={(i + 1).toString().padStart(2, "0")}>
                          {i + 1}
                        </option>
                      ))}
                    </Select>
                    <Select
                      placeholder={t("DialogEnrollSubject.birthDate_month")}
                      value={birthMonth}
                      onChange={(e) => {
                        setBirthMonth(e.target.value);
                      }}
                    >
                      {Array.from({ length: 12 }, (_, i) => {
                        const monthNum = (i + 1).toString().padStart(2, "0");
                        return (
                          <option key={monthNum} value={monthNum}>
                            {t(`months.${monthNum}`)}
                          </option>
                        );
                      })}
                    </Select>
                    <Select
                      placeholder="ปี"
                      value={birthYear}
                      onChange={(e) => {
                        setBirthYear(e.target.value);
                      }}
                    >
                      {Array.from({ length: 100 }, (_, i) => {
                        const year = (new Date().getFullYear() - 99 + i).toString();
                        const thaiYear = (parseInt(year) + 543).toString();
                        return (
                          <option key={year} value={year}>
                            {thaiYear}
                          </option>
                        );
                      })}
                    </Select>
                  </Stack>
                </FormControl>

                <FormControl>
                  <FormLabel>{t("DialogEnrollSubject.status")}</FormLabel>
                  <RadioGroup
                    name="status"
                    value={formQuestionare.status}
                    onChange={(val) => setFormQuestionare((prev) => ({ ...prev, status: val }))}
                  >
                    <Stack spacing={2}>
                      <Radio value="โสด">1. {t("DialogEnrollSubject.status_options.single")}</Radio>
                      <Radio value="สมรส">2. {t("DialogEnrollSubject.status_options.married")}</Radio>
                      <Radio value="หย่า/หม้าย">3. {t("DialogEnrollSubject.status_options.divorced")}</Radio>
                    </Stack>
                  </RadioGroup>
                </FormControl>

                <FormControl>
                  <FormLabel>{t("DialogEnrollSubject.education")}</FormLabel>
                  <RadioGroup
                    name="education"
                    value={formQuestionare.education}
                    onChange={(val) =>
                      setFormQuestionare((prev) => ({
                        ...prev,
                        education: val,
                      }))
                    }
                  >
                    <Stack spacing={2}>
                      <Radio value="ต่ำกว่าปริญญาตรี">
                        1. {t("DialogEnrollSubject.education_options.belowBachelor")}
                      </Radio>
                      <Radio value="ปริญญาตรี">2. {t("DialogEnrollSubject.education_options.bachelor")}</Radio>
                      <Radio value="สูงกว่าปริญญาตรี">
                        3. {t("DialogEnrollSubject.education_options.aboveBachelor")}
                      </Radio>
                    </Stack>
                  </RadioGroup>
                </FormControl>

                <FormControl>
                  <FormLabel>{t("DialogEnrollSubject.department")}</FormLabel>
                  <Input name="department" value={formQuestionare.department} onChange={handleInput} />
                </FormControl>

                <FormControl>
                  <FormLabel>{t("DialogEnrollSubject.position")}</FormLabel>
                  <Input name="position" value={formQuestionare.position} onChange={handleInput} />
                </FormControl>

                <FormControl>
                  <FormLabel>{t("DialogEnrollSubject.roles")}</FormLabel>
                  <CheckboxGroup value={formQuestionare.roles} onChange={(val) => handleCheckbox("roles", val)}>
                    <Stack spacing={2}>
                      <Checkbox value="พี่เลี้ยงเดิม">{t("DialogEnrollSubject.role_options.oldMentor")}</Checkbox>
                      <Checkbox value="พี่เลี้ยงใหม่">{t("DialogEnrollSubject.role_options.newMentor")}</Checkbox>
                      <Checkbox value="เครือข่ายกองทุน (กรรมการ)">
                        {t("DialogEnrollSubject.role_options.networkCommittee")}
                      </Checkbox>
                      <Checkbox value="เครือข่ายกองทุน (เจ้าหน้าที่)">
                        {t("DialogEnrollSubject.role_options.networkOfficer")}
                      </Checkbox>
                      <Checkbox value="เครือข่ายกองทุน (ผู้เสนอโครงการ)">
                        {t("DialogEnrollSubject.role_options.networkProposer")}
                      </Checkbox>
                      <Checkbox value="ผู้เก็บข้อมูลสถานการณ์สุขภาพชุมชน (ผู้เก็บแบบสอบถาม)">
                        {t("DialogEnrollSubject.role_options.enumerator")}
                      </Checkbox>
                      <Checkbox value="อื่นๆ">{t("DialogEnrollSubject.role_options.other")}</Checkbox>
                    </Stack>
                  </CheckboxGroup>
                  {formQuestionare.roles.includes("อื่นๆ") && (
                    <Input
                      mt={2}
                      placeholder={t("DialogEnrollSubject.role_options.other")}
                      name="otherRole"
                      value={formQuestionare.otherRole}
                      onChange={handleInput}
                    />
                  )}
                </FormControl>

                <FormControl>
                  <FormLabel>{t("DialogEnrollSubject.location")}</FormLabel>
                  <Stack spacing={2}>
                    <Select
                      placeholder={t("DialogEnrollSubject.healthZone")}
                      name="healthZone"
                      value={formQuestionare.healthZone}
                      onChange={handleInput}
                    >
                      {Array.from({ length: 13 }, (_, i) => (
                        <option key={i + 1} value={String(i + 1)}>
                          {t("DialogEnrollSubject.healthZone")} {i + 1}
                        </option>
                      ))}
                    </Select>
                    <Input
                      placeholder={t("DialogEnrollSubject.province")}
                      name="province"
                      value={formQuestionare.province}
                      onChange={handleInput}
                    />
                    <Input
                      placeholder={t("DialogEnrollSubject.district")}
                      name="district"
                      value={formQuestionare.district}
                      onChange={handleInput}
                    />
                    <Input
                      placeholder={t("DialogEnrollSubject.subDistrict")}
                      name="subDistrict"
                      value={formQuestionare.subDistrict}
                      onChange={handleInput}
                    />
                    <Input
                      placeholder={t("DialogEnrollSubject.fund")}
                      name="fund"
                      value={formQuestionare.fund}
                      onChange={handleInput}
                    />
                  </Stack>
                </FormControl>

                <FormControl>
                  <FormLabel>{t("DialogEnrollSubject.fundTypes")}</FormLabel>
                  <CheckboxGroup value={formQuestionare.fundTypes} onChange={(val) => handleCheckbox("fundTypes", val)}>
                    <Stack spacing={2}>
                      <Checkbox value="ศูนย์เรียนต้นแบบ">
                        {t("DialogEnrollSubject.fundType_options.modelCenter")}
                      </Checkbox>
                      <Checkbox value="สมัครใจ">{t("DialogEnrollSubject.fundType_options.voluntary")}</Checkbox>
                    </Stack>
                  </CheckboxGroup>
                </FormControl>
              </Stack>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={closeDialogEnrollSubject}>
              {t("Button.close")}
            </Button>
            <Button variant="solid" colorScheme="red" type="submit">
              {t("Button.confirm")}
            </Button>
          </ModalFooter>
        </ModalContent>
      </form>
    </Modal>
  );
};

export default DialogEnrollSubject;
